// eslint-disable @typescript-eslint/no-explicit-any -- this file has bivariant types that are not easily expressed in TypeScript
export function pipe<A, B>(fn1: (arg: A) => B): (arg: A) => B
export function pipe<A, B, C>(fn1: (arg: A) => B, fn2: (arg: B) => C): (arg: A) => C
export function pipe<A, B, C, D>(
  fn1: (arg: A) => B,
  fn2: (arg: B) => C,
  fn3: (arg: C) => D
): (arg: A) => D
export function pipe<A, B, C, D, E>(
  fn1: (arg: A) => B,
  fn2: (arg: B) => C,
  fn3: (arg: C) => D,
  fn4: (arg: D) => E
): (arg: A) => E
export function pipe<A, B, C, D, E, F>(
  fn1: (arg: A) => B,
  fn2: (arg: B) => C,
  fn3: (arg: C) => D,
  fn4: (arg: D) => E,
  fn5: (arg: E) => F
): (arg: A) => F
export function pipe<A, B, C, D, E, F, G>(
  fn1: (arg: A) => B,
  fn2: (arg: B) => C,
  fn3: (arg: C) => D,
  fn4: (arg: D) => E,
  fn5: (arg: E) => F,
  fn6: (arg: F) => G
): (arg: A) => G
export function pipe<A, B, C, D, E, F, G, H>(
  fn1: (arg: A) => B,
  fn2: (arg: B) => C,
  fn3: (arg: C) => D,
  fn4: (arg: D) => E,
  fn5: (arg: E) => F,
  fn6: (arg: F) => G,
  fn7: (arg: G) => H
): (arg: A) => H
export function pipe<A, B, C, D, E, F, G, H, I>(
  fn1: (arg: A) => B,
  fn2: (arg: B) => C,
  fn3: (arg: C) => D,
  fn4: (arg: D) => E,
  fn5: (arg: E) => F,
  fn6: (arg: F) => G,
  fn7: (arg: G) => H,
  fn8: (arg: H) => I
): (arg: A) => I
export function pipe<A, B, C, D, E, F, G, H, I, J>(
  fn1: (arg: A) => B,
  fn2: (arg: B) => C,
  fn3: (arg: C) => D,
  fn4: (arg: D) => E,
  fn5: (arg: E) => F,
  fn6: (arg: F) => G,
  fn7: (arg: G) => H,
  fn8: (arg: H) => I,
  fn9: (arg: I) => J
): (arg: A) => J
export function pipe<A, B, C, D, E, F, G, H, I, J, K>(
  fn1: (arg: A) => B,
  fn2: (arg: B) => C,
  fn3: (arg: C) => D,
  fn4: (arg: D) => E,
  fn5: (arg: E) => F,
  fn6: (arg: F) => G,
  fn7: (arg: G) => H,
  fn8: (arg: H) => I,
  fn9: (arg: I) => J,
  fn10: (arg: J) => K
): (arg: A) => K
export function pipe(...fns: Array<(arg: any) => any>): (arg: any) => any {
  return (value: any) => fns.reduce((acc, fn) => fn(acc), value)
}

export function compose<A, B>(fn1: (arg: A) => B): (arg: A) => B
export function compose<A, B, C>(fn1: (arg: B) => C, fn2: (arg: A) => B): (arg: A) => C
export function compose<A, B, C, D>(
  fn1: (arg: C) => D,
  fn2: (arg: B) => C,
  fn3: (arg: A) => B
): (arg: A) => D
export function compose<A, B, C, D, E>(
  fn1: (arg: D) => E,
  fn2: (arg: C) => D,
  fn3: (arg: B) => C,
  fn4: (arg: A) => B
): (arg: A) => E
export function compose<A, B, C, D, E, F>(
  fn1: (arg: E) => F,
  fn2: (arg: D) => E,
  fn3: (arg: C) => D,
  fn4: (arg: B) => C,
  fn5: (arg: A) => B
): (arg: A) => F
export function compose<A, B, C, D, E, F, G>(
  fn1: (arg: F) => G,
  fn2: (arg: E) => F,
  fn3: (arg: D) => E,
  fn4: (arg: C) => D,
  fn5: (arg: B) => C,
  fn6: (arg: A) => B
): (arg: A) => G
export function compose<A, B, C, D, E, F, G, H>(
  fn1: (arg: G) => H,
  fn2: (arg: F) => G,
  fn3: (arg: E) => F,
  fn4: (arg: D) => E,
  fn5: (arg: C) => D,
  fn6: (arg: B) => C,
  fn7: (arg: A) => B
): (arg: A) => H
export function compose<A, B, C, D, E, F, G, H, I>(
  fn1: (arg: H) => I,
  fn2: (arg: G) => H,
  fn3: (arg: F) => G,
  fn4: (arg: E) => F,
  fn5: (arg: D) => E,
  fn6: (arg: C) => D,
  fn7: (arg: B) => C,
  fn8: (arg: A) => B
): (arg: A) => I
export function compose<A, B, C, D, E, F, G, H, I, J>(
  fn1: (arg: I) => J,
  fn2: (arg: H) => I,
  fn3: (arg: G) => H,
  fn4: (arg: F) => G,
  fn5: (arg: E) => F,
  fn6: (arg: D) => E,
  fn7: (arg: C) => D,
  fn8: (arg: B) => C,
  fn9: (arg: A) => B
): (arg: A) => J
export function compose<A, B, C, D, E, F, G, H, I, J, K>(
  fn1: (arg: J) => K,
  fn2: (arg: I) => J,
  fn3: (arg: H) => I,
  fn4: (arg: G) => H,
  fn5: (arg: F) => G,
  fn6: (arg: E) => F,
  fn7: (arg: D) => E,
  fn8: (arg: C) => D,
  fn9: (arg: B) => C,
  fn10: (arg: A) => B
): (arg: A) => K
export function compose(...fns: Array<(arg: any) => any>): (arg: any) => any {
  return (value: any) => fns.reduceRight((acc, fn) => fn(acc), value)
}

/**
 * Runs `fn` at most once per `windowMs`. A call while idle runs at once; calls inside the window
 * collapse into a single run at its end, with the arguments of the latest call.
 */
export const throttle = <Args extends unknown[]>(fn: (...args: Args) => void, windowMs: number) => {
  let lastRunAt: number | null = null
  let pending: ReturnType<typeof setTimeout> | undefined

  const run = (args: Args) => {
    lastRunAt = Date.now()
    pending = undefined
    fn(...args)
  }

  return (...args: Args) => {
    clearTimeout(pending)
    const elapsed = lastRunAt === null ? Infinity : Date.now() - lastRunAt
    if (elapsed >= windowMs) {
      run(args)
    } else {
      pending = setTimeout(() => run(args), windowMs - elapsed)
    }
  }
}
